import { cn } from '@/utils/cn';
import { memo } from 'react';

interface IFileIconProps {
  file: { file: File | { type: string; name: string } };
  className?: string;
}

const FileIcon = memo(({ file, className }: IFileIconProps) => {
  if (!file) return null;

  const fileName = file?.file instanceof File ? file?.file?.name : file?.file?.name;

  // Extract file extension
  const getFileExtension = (name: string): string => {
    const lastDot = name.lastIndexOf('.');
    if (lastDot === -1) return 'FILE';
    return name
      .substring(lastDot + 1)
      .toUpperCase()
      .slice(0, 4);
  };

  const extension = getFileExtension(fileName);

  return (
    <div className={cn('opacity-100 flex-shrink-0  flex items-center justify-center bg-white', className)}>
      <span className="text-[13px] font-medium text-foreground leading-none">{extension}</span>
    </div>
  );
});
FileIcon.displayName = 'FileIcon';

export default FileIcon;
